// extracted by mini-css-extract-plugin
export var colorSquare = "_qa-0";
export var danger = "_qa-5";
export var lightPink = "_qa-8";
export var neutralBlue = "_qa-7";
export var neutralYellow = "_qa-6";
export var normal = "_qa-1";
export var primary = "_qa-2";
export var primaryLight = "_qa-3";
export var solidBlack = "_qa-g";
export var solidGreen = "_qa-b";
export var solidLightBlue = "_qa-d";
export var solidNavy = "_qa-c";
export var solidOrange = "_qa-f";
export var solidPink = "_qa-e";
export var solidRed = "_qa-9";
export var solidYellow = "_qa-a";
export var success = "_qa-4";